import React from 'react'

import { Account } from '@driftt/api-types'
import { Flex } from '@driftt/dds'

import { CompanyData, ScoreBreakdown } from 'modules/accountActivity/domain'

import AccountInfoRow from './AccountInfoRow'
import CompanyInfoRow from './CompanyInfoRow'
import NavigationTabs from './NavigationTabs'

interface AccountDetailsHeaderProps {
  activeTab: string
  tabNames: string[]
  onTabSelected: (selectedTab: string) => void
  account: Account | undefined
  company: CompanyData | undefined
  explainData: any | undefined
  salesforceData: any | undefined
  accountFitScore: number | undefined
  scoreBreakdown: ScoreBreakdown | undefined
  numOfOpportunities: React.ReactNode
}

const AccountDetailsHeader = ({
  account,
  explainData,
  company,
  salesforceData,
  activeTab,
  tabNames,
  onTabSelected,
  accountFitScore,
  scoreBreakdown,
  numOfOpportunities
}: AccountDetailsHeaderProps) => {

  return (
    <Flex
      direction="column"
      gap={0}
      css={{
        backgroundColor: '$white',
        padding: '$5 $5 $0 $5',
        position: 'sticky',
        top: 0,
        borderBottom: '1px solid $gray3',
        zIndex: 900
      }}>
      <CompanyInfoRow
        account={account}
        company={company}
        explainData={explainData}
        salesforceData={salesforceData}
      />

      <Flex
        css={{ padding: '$2 0', borderBottom: '1px solid $gray3' }}
        alignItems="center"
        justifyContent="space-evenly"
        fullWidth
        gap={2}>
        <AccountInfoRow
          account={account}
          company={company}
          accountFitScore={accountFitScore}
          scoreBreakdown={scoreBreakdown}
          numOfOpportunities={numOfOpportunities}
          accountEngagement={explainData?.normalizedEngagementScore}
          showEngagementScore={false}
        />
      </Flex>
      <NavigationTabs activeTab={activeTab} tabNames={tabNames} onTabSelected={onTabSelected} />
    </Flex>
  )
}

export default AccountDetailsHeader
